<div class="page-layout-container">
  <div class="row">
    <h1 class="title">Employee Yearly Report</h1>
  </div>

  <div class="row">
    <div class="col-6" style="width: 80%">
      <app-emp-name (empName)="empNameSelected($event)"> </app-emp-name>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>Select Year for generating report</mat-label>
        <input
          matInput
          [matDatepicker]="leaveEndDate"
          required
          (dateChange)="fetchMonthlyReport($event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaveEndDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaveEndDate></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  &nbsp;&nbsp;
  <div class="section">
    <div class="row">
      <h1 class="title">Monthly Revenues</h1>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="month">
        <th mat-header-cell *matHeaderCellDef>Month</th>
        <td mat-cell *matCellDef="let element">{{ element.month }}</td>
      </ng-container>

      <ng-container matColumnDef="nishContractId">
        <th mat-header-cell *matHeaderCellDef>NISH Contract</th>
        <td mat-cell *matCellDef="let element">{{ element.nishContractId }}</td>
      </ng-container>

      <ng-container matColumnDef="actualWorkingDays">
        <th mat-header-cell *matHeaderCellDef>Actual Working Days</th>
        <td mat-cell *matCellDef="let element">
          {{ element.actualWorkingDays }}
        </td>
      </ng-container>

      <ng-container matColumnDef="daysWorked">
        <th mat-header-cell *matHeaderCellDef>Days Worked</th>
        <td mat-cell *matCellDef="let element">
          {{ element.daysWorked }}
        </td>
      </ng-container>

      <ng-container matColumnDef="billingRate">
        <th mat-header-cell *matHeaderCellDef>Billing Rate</th>
        <td mat-cell *matCellDef="let element">
          {{ element.billingRate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Total Billing</th>
        <td mat-cell *matCellDef="let element">{{ element.amount }}</td>
      </ng-container>

      <ng-container matColumnDef="marginPerMonth">
        <th mat-header-cell *matHeaderCellDef>Margin</th>
        <td mat-cell *matCellDef="let element">{{ element.marginPerMonth }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  &nbsp;&nbsp;
  <div class="section">
    <div class="row">
      <h1 class="title">Summary</h1>
    </div>
    <form [formGroup]="employeeYearlyReport">
      <div class="row">
        <div class="col">
          <mat-form-field style="width: 100%">
            <mat-label>Gross per Month </mat-label>
            <input
              matInput
              type="number"
              [readonly]="true"
              formControlName="salPerMonth"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field style="width: 100%">
            <mat-label>CTC</mat-label>
            <input
              matInput
              type="number"
              [readonly]="true"
              formControlName="employeeCTC"
            />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field style="width: 100%">
            <mat-label>Total Revenue Generated</mat-label>
            <input
              matInput
              type="number"
              [readonly]="true"
              formControlName="totalRevenueGenerated"
            />
          </mat-form-field>
        </div>
        <div class="col" style="width: 100%">
          <mat-form-field>
            <mat-label> Revenue yet to generate</mat-label>
            <input
              matInput
              type="number"
              [readonly]="true"
              formControlName="totalEmpExpenses"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="row"></div>
    </form>
  </div>
</div>
